import styled from "styled-components";

import { Rate } from "./rate";
import { Qualification } from "@src/appV2/Admin/Qualifications/types";

const Container = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  li {
    display: inline-block;
  }
`;

interface WorkerRateProps {
  qualifications: Qualification[];
  rates: Record<string, number>;
  onChange: (change: Record<string, number>) => void;
}

export function WorkerRate(props: WorkerRateProps) {
  const { qualifications, rates, onChange } = props;

  return (
    <Container>
      {qualifications.map(({ attributes }) => (
        <li key={attributes.name}>
          <Rate
            qualificationName={attributes.name}
            qualificationLabel={attributes.displayLabel}
            onChange={onChange}
            value={rates?.[attributes.name]}
          />
        </li>
      ))}
    </Container>
  );
}
